(function () {
    'use strict';

    angular
        .module('app')
        .factory('clientService', clientService);

    clientService.$inject = ['$http', '$q', '$interval', '$injector', '$mdDialog', '$localStorage', '$rootScope', '$timeout', '$location', 'optionsService'];

    function clientService($http, $q, $interval, $injector, $mdDialog, $localStorage, $rootScope, $timeout, $location, optionsService) {
        var service = {
            get: get,
            post: post,
            put: put,
            delete: del,
            connected: false,
            showDownloadDialog: showDownloadDialog,
            checkACS: checkACS,
            needsUpdate: false,
            needsACSUpdate: false,
            needsRealDWGUpdate: false,
            needsViewerUpdate: false,
            updateNotified: false,
            signalRConnected: false,
            usingNewViewer: false,
            getPdfFile: getPdfFile,
            disconnect: disconnect,
            getViewerLogFile: getViewerLogFile,
            getCombinedPdfFile: getCombinedPdfFile,
            close: close
        };

        var defaultPort = window.location.protocol == "http:" ? "4040" : "4343";
        var port = $localStorage.acsPort ? $localStorage.acsPort : defaultPort;

        var ACSURL = window.location.protocol + "//localhost:" + port;
        var refreshToken = "";
        var dialogShown = false;
        var timeObj = {};
        service.success = false;
        var timeout;

        //signalR connection
        var connection = null;
        var httpRequest = function (type, url, data, suppressError, headers, dataType) {
            //console.log("httpRequest - clientService");
            var loginService = $injector.get('loginService');
            var deferred = $q.defer();
            url = ACSURL + "/api/" + url;

            if (headers) {
                headers.Authorization = "Bearer " + loginService.acs_token;
                headers = JSON.stringify(headers);
            }
            else {
                headers = { "Authorization": "Bearer " + loginService.acs_token, "Content-Type": "application/json" };
            }

            if (service.success) {
                var answer = $timeout.cancel(timeout);
                if (answer) {
                    loginService.log("SUCCESSFULLY CANCELED THE TIMEOUT, SUCCESS HAS BEEN LEFT TRUE");
                }
            }

            if (dataType) {
                console.log(dataType);
            }

            checkACS(service.success).then(function () {
                service.success = true

                timeout = $timeout(function () {
                    var loginService = $injector.get('loginService');
                    loginService.log("TASK EXECUTED SUCCESS SET TO FALSE");
                    service.success = false;
                }, 10000);

                timeObj = new Date();
                $.ajax({
                    type: type,
                    url: url,
                    data: JSON.stringify(data),
                    headers: headers,
                    dataType: dataType,
                    success: function (result) {
                        end(url);
                        deferred.resolve(result);
                    },
                    error: function (request, status, error) {
                        if (request.responseJSON) {
                            if (request.responseJSON.Message.indexOf("Authorization has been denied") != -1) {
                                error = "Unauthorized";
                            }
                        }

                        if (error == "Unauthorized") {
                            login().then(function () {
                                //retry request
                                $.ajax({
                                    type: type,
                                    url: url,
                                    data: JSON.stringify(data),
                                    headers: { "Authorization": "Bearer " + loginService.acs_token, "Content-Type": "application/json" },
                                    error: function (request, status, error) {
                                        handleError(request, error, suppressError);
                                        deferred.reject(request);
                                    }
                                }).done(function (result) {
                                    deferred.resolve(result);
                                });
                            }, function () {
                                handleError(request, error, suppressError);
                                deferred.reject(request);
                            });
                        }
                        else {
                            handleError(request, error, suppressError);
                            deferred.reject(request);
                        }
                    }
                });

            }, function (error) {
                if (error === "NOTSUPPORTED" && $location.path().indexOf('viewpdf') == -1) {
                    //console.log();
                    alert("Creator is not supported on this Operating System. All Creator features will be disabled.");
                }
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getPdfFile(item) {
            var loginService = $injector.get('loginService');
            return $http({
                url: ACSURL + "/api/viewer/GetPDFFile",
                method: "POST",
                responseType: "blob",
                data: JSON.stringify(item),
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + loginService.acs_token,
                }
            });
        }

        function getCombinedPdfFile(items) {
            var loginService = $injector.get('loginService');
            return $http({
                url: ACSURL + "/api/Viewer/CombinePdfFiles",
                method: "POST",
                responseType: "blob",
                data: JSON.stringify(items),
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + loginService.acs_token,
                }
            });
        }

        function getViewerLogFile(fileId, majRev, minRev) {
            var loginService = $injector.get('loginService');
            return $http({
                url: ACSURL + "/api/viewer/GetLogFile?fileId=" + fileId + "&majRev=" + majRev + "&minRev=" + minRev,
                method: "GET",
                responseType: "application/text",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + loginService.acs_token,
                }
            });
        }


        return service;

        function handleError(request, error, suppressError) {
            if (error == "Not Acceptable") {
                return;
            }
            if (!suppressError) {
                if (request.responseJSON) {

                    if (request.responseJSON.ExceptionMessage) {
                        var type = request.responseJSON.ExceptionType ? "(ACS) " + request.responseJSON.ExceptionType : "(ACS) Error";
                        var message = request.responseJSON.ExceptionMessage ? request.responseJSON.ExceptionMessage : request.responseJSON.message;
                        $rootScope.msgBoxShow(message, type, 3, true);
                        return;
                    }

                    // Still not showing correct exception from ACS. Look for responseText first.
                    if (request.responseJSON.Message != null && request.responseJSON.Message.length > 0) {
                        var loginService = $injector.get('loginService');
                        var errTitle = "(ACS) " + loginService.resourceStrings["ERROR"];
                        $rootScope.msgBoxShow(request.responseJSON.Message, errTitle, 3, true);
                        return;
                    }


                }
                else {
                    $rootScope.msgBoxShow(error, "Error", 3, true);
                }
            }
        }


        function checkACS(skipCheck) {
            var deferred = $q.defer();
            //console.log("checkACS called");


            //when making calls in a loop we should skip the acs check
            if (skipCheck) {
                //console.log("skipping check");
                var loginService = $injector.get('loginService');
                loginService.log("CHECK HAS BEEN SKIPED");
                deferred.resolve();
                return deferred.promise;
            }

            $http.get('../Synergis.WebApi/api/AdminOptions/MultiInstanceSupport').then(function (response) {
                //console.log("Multi Instance support =", response);
                var bMis = response.data;             

                //if multiple instance enabled, try to get the port from local storage
                if (bMis) {
                    //if the port is not in local storage, we will start with 4040. Otherwise we will use the value stored.
                    if ($localStorage.acsPort) {
                        port = $localStorage.acsPort;
                        ACSURL = window.location.protocol + "//localhost:" + port;
                    }
                }
                else {
                    $localStorage.acsPort = undefined;
                    port = window.location.protocol == "http:" ? "4040" : "4343";
                    ACSURL = window.location.protocol + "//localhost:" + port;
                }

                var url = ACSURL + "/api/status?id=" + $localStorage.acsId;
                //check if it's windows
                if (bowser.windows) {
                    console.log("checking acs on port: " + port);
                    $.ajax({
                        type: 'GET',
                        url: url,
                        timeout: 1000,
                        success: function (pckg) {
                            checkVersions(pckg).then(function () {
                                if (!service.signalRConnected) {
                                    connectSignalR();
                                }
                                deferred.resolve();


                            }, function () {
                                deferred.reject();
                            });
                        },
                        error: function (request, status, error) {
                            
                            //try to launch if ACS is not installed
                            var args = "start";
                            if (!$localStorage.acsId) {
                                $localStorage.acsId = uuidv4();
                            }

                            if (error == "Not Acceptable" && bMis) {
                                
                                //incresease the port number to start another instance
                                port = parseInt(port) + 1;
                                //4045 is tagged as unsafe in chrome and FF
                                if (port === 4045) {
                                    port = 4046;
                                }
                                ACSURL = window.location.protocol + "//localhost:" + port;
                                console.log("Wrong instance, trying port: " + port);
                                $localStorage.acsPort = port;
                                return checkACS().then(function () {
                                    deferred.resolve();
                                });
                            }
                            else {
                                var uuid = $localStorage.acsId;
                                args = args + '&id=' + uuid;
                                //args = args + '&port=' + port;
                                if (window.location.protocol == "https:") {
                                    args = args + "&secure";
                                }

                                args = args + "&port=" + port;
                                if (bMis) {
                                    args = args + "&mis";
                                }

                                //debug
                                //args = args + "&status";
                                //send the browser name

                                args = args + "&browser=" + bowser.name;

                                window.protocolCheck("adeptclientservices:" + args, function () {
                                    //alert("protocol not supported");
                                    var loginService = $injector.get('loginService');
                                    //here we ask the user if they would like to download.
                                    if (!$localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt) {
                                        $timeout(function () {
                                            if (!service.connected)
                                                showDownloadDialog('download');
                                        }, 5000);

                                    }
                                });

                                //if Unauthorized, try to login
                                var interval = waitForACS(90).then(function () {
                                    //could not connect, show the download screen.
                                    deferred.reject();
                                }, function () {
                                    deferred.resolve();
                                });
                            }
                        }
                    });
                }
                //other OSs not supported
                else {
                    deferred.reject("NOTSUPPORTED");
                }
            }, function () {
                    console.log("got an error in multi instance support call");
            });
            return deferred.promise;
        }

        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        }

        function waitForACS(timeout) {
            timeout = timeout ? timeout : 30;
            var interval = $interval(function () {
                if (!dialogShown) {
                    $.ajax({
                        type: 'GET',
                        url: ACSURL + "/api/status?id=" + $localStorage.acsId,
                        success: function (pckg) {
                            service.connected = true;
                            checkVersions(pckg).then(function () {
                                if (!service.signalRConnected && !service.signalRConnecting) {
                                    connectSignalR();
                                }
                                $interval.cancel(interval);
                            }, function () {
                                $interval.cancel(interval);
                            });
                        },
                        error: function (request, status, error) {
                            if (error == "Not Acceptable") {
                                //$interval.cancel(interval);
                            }
                            service.connected = false;
                        }
                    });
                }
            }, 1000, timeout);
            return interval;
        }

        function login() {
            var deferred = $q.defer();
            var loginService = $injector.get('loginService');
            //if we get here we already know that ACS is up and running.
            loginService.logInACS(ACSURL).then(function () {
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        }

        function checkVersions(pckg) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebAPI/api/package/clientservices/version').then(function (response) {
                var serverVersion = response.data;

                if (compareVersions(pckg.ACS, serverVersion) == -1 || !pckg.ACS) {
                    service.connected = false;
                    service.needsUpdate = true;
                    service.needsACSUpdate = true;
                }
                else {
                    service.connected = true;
                    service.needsACSUpdate = false;
                }

                var loginService = $injector.get('loginService');


                optionsService.getViewerOptions().then(function (viewerOptions) {

                    service.usingNewViewer = viewerOptions["NewViewer"] == "true";

                    //check viewer
                    checkViewerVersion(pckg.ViewerInstalled).then(function (needViewerUpdate) {

                        if (service.usingNewViewer)
                            service.needsViewerUpdate = needViewerUpdate;

                        //if viewer needs update, set the needupdate flag to true
                        if (needViewerUpdate && service.usingNewViewer)
                            service.needsUpdate = true;

                        //check realdwg
                        checkRealDWGVersion(pckg.RealDWG).then(function (needRealDWGupdate) {
                            service.needsRealDWGUpdate = needRealDWGupdate;

                            //if realdwg needs update, set the needupdate flag to true
                            if (needRealDWGupdate)
                                service.needsUpdate = true;

                            //if needsupdate flag is true
                            if (service.needsUpdate) {
                                //check if the user has been notified yet
                                if (!service.updateNotified) {
                                    //mark as notified
                                    service.updateNotified = true;

                                    //if the user has not disabled the download page, show the the download page
                                    if (!$localStorage.perUserSettings[loginService.id].disableACSDownloadPrompt) {
                                        showDownloadDialog();
                                    }
                                }
                                else {
                                    //nothing needs updating
                                    service.connected = true;
                                    service.needsACSUpdate = false;
                                }
                                deferred.resolve();
                            }
                            else {
                                //nothing needs updating
                                service.connected = true;
                                service.needsACSUpdate = false;
                                deferred.resolve();
                            }
                        });
                    });
                });
            }, function () {
                deferred.reject(serverVersion);
            });
            return deferred.promise;
        }


        function checkRealDWGVersion(localVersion) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebAPI/api/package/realdwg/version').then(function (response) {
                var serverVersion = response.data;

                if (localVersion == "0")
                    deferred.resolve(false);

                if (compareVersions(localVersion, serverVersion) == -1) {
                    deferred.resolve(true);
                }
                else {
                    deferred.resolve(false);
                }
            }, function () {
                deferred.reject(true);
            });
            return deferred.promise;
        }


        function checkViewerVersion(localVersion) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebAPI/api/package/localviewer/version').then(function (response) {
                var serverVersion = response.data;

                if (localVersion == "0")
                    deferred.resolve(false);

                if (compareVersions(localVersion, serverVersion) == -1) {
                    deferred.resolve(true);
                }
                else {
                    deferred.resolve(false);
                }
            }, function () {
                deferred.reject(true);
            });
            return deferred.promise;
        }



        function get(command, suppressError) {
            return httpRequest("GET", command, undefined, suppressError);
        }
        function post(command, data, suppressError, headers, dataType) {
            return httpRequest("POST", command, data, suppressError, headers, dataType);
        }
        function put(command, data, suppressError) {
            return httpRequest("PUT", command, data, suppressError);
        }
        function del(command, data, suppressError) {
            return httpRequest("DEL", command, data, suppressError);
        }

        function showDownloadDialog(template) {
            var deferred = $q.defer();
            dialogShown = true;
            $http.get('../Synergis.WebAPI/api/adminoptions/ACSInstallerFilename').then(function (resp) {
                if (!template)
                    template = "updateacs";

                $mdDialog.show({
                    locals: {
                        needUpdate: { acs: service.needsACSUpdate, realdwg: service.needsRealDWGUpdate, viewer: service.needsViewerUpdate },
                        acsFilename: resp.data,
                        newViewer: service.usingNewViewer
                    },
                    controller: 'acsDownloadPage',
                    controllerAs: 'vm',
                    templateUrl: 'app/clientservices/templates/' + template + '.html',
                    parent: angular.element(document.body)
                })
                .then(function (answer) {
                    dialogShown = false;
                    checkACS();
                    deferred.resolve();
                }, function () {
                    deferred.resolve();
                });
            });

            return deferred.promise;
        }

        function compareVersions(a, b) {
            if (a === b) {
                return 0;
            }
            try {
                var a_components = a.split(".");
                var b_components = b.split(".");
            } catch (e) {
                return 0;
            }


            var len = Math.min(a_components.length, b_components.length);

            // loop while the components are equal
            for (var i = 0; i < len; i++) {
                // A bigger than B
                if (parseInt(a_components[i].replace(/\D/g, '')) > parseInt(b_components[i].replace(/\D/g, ''))) {
                    return 1;
                }

                // B bigger than A
                if (parseInt(a_components[i].replace(/\D/g, '')) < parseInt(b_components[i].replace(/\D/g, ''))) {
                    return -1;
                }
            }

            // If one's a prefix of the other, the longer one is greater.
            if (a_components.length > b_components.length) {
                return 1;
            }

            if (a_components.length < b_components.length) {
                return -1;
            }

            // Otherwise they are the same.
            return 0;
        }

        function connectSignalR() {
            service.signalRConnecting = true;
            var loginService = $injector.get('loginService');
            connection = $.hubConnection(ACSURL);
            var proxy = connection.createHubProxy("connectionHub");
            proxy.on('ping', function (message) {
                loginService.log(message);
            });
            connection.start().done(function () {
                service.signalRConnected = true;
                service.signalRConnecting = false;
                service.connectionId = connection.id;

                loginService.log("Connected to ACS SignalR Connection Id:", connection.id);

                connection.disconnected(function () {
                    service.signalRConnected = false;
                    service.connected = false;
                    service.signalRConnecting = false;
                });
                connection.error(function () {
                    service.signalRConnected = false;
                    service.connected = false;
                    service.signalRConnecting = false;
                });
                connection.reconnected(function () {
                    service.signalRConnecting = false;
                    service.connected = true;
                    service.signalRConnected = true;
                    loginService.log("ACS SignalR Reconnected");
                });
            });

        }

        function end(desc) {

            var endTime = new Date();
            var timeDiff = endTime - timeObj; //in ms
            // strip the ms
            //timeDiff /= 1000;

            // get seconds 
            var seconds = Math.round(timeDiff);
            var loginService = $injector.get('loginService');
            loginService.log(desc + " : " + seconds + " milliseconds");
        }

        function disconnect() {
            if (connection) {
                connection.stop();

            }
        }

        function close() {
            disconnect();
            service.acs_token = "";
            service.signalRConnected = false;
            connection = null;
        }


    }
})();